import React, { useContext, useState } from "react";
import Logo from "../../../assets/logoOlin.png";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineShop } from "react-icons/ai";
import { IoCart, IoLocationSharp } from "react-icons/io5";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addToCart } from "../../../services/purchaseApi";
import Cookies from "js-cookie";
import { FaMinus, FaPlus, FaSpinner } from "react-icons/fa";
import moment from "moment";
import Mascot from "../../../assets/olin-mascot.png";
import { GlobalStateContext } from "../../../components/context/GlobalStateContext";

const timeNow = moment().format("HH:mm");

const ProductCard = ({
  item,
  index,
  setItems,
  setOpenModalRecipe,
  setAddToCartProduct,
  setChatRecipeResponse,
  setDoctorRecipe,
  setOpenModalChatRecipe,
  fetchLimit,
  setHasMore,
  setOpen,
  recipeImg,
}) => {
  const { recipeId, isLogin } = useContext(GlobalStateContext);
  const fullname = localStorage.getItem("fullname");
  const machineId = localStorage.getItem("MachineId");
  const companyId = localStorage.getItem("companyId")
    ? Number(localStorage.getItem("companyId"))
    : 0;
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [isLoading, setIsLoading] = useState(false);
  const [prodQuantity, setProdQuantity] = useState(0);

  const handleAddToCart = (body) => {
    mutateAddToCart(body);
  };

  const handleSuccessAddToCart = () => {
    setItems((prevValue) =>
      prevValue.map((data) => ({
        ...data,
        quantity_buffer: 0,
        isLoading: false,
      }))
    );
    queryClient.invalidateQueries({
      queryKey: ["product-list"],
    });
    queryClient.invalidateQueries({
      queryKey: ["count-cart"],
    });
    queryClient.invalidateQueries({
      queryKey: ["count-cart-jwt"],
    });

    setIsLoading(false);
  };

  const { mutate: mutateAddToCart, isLoading: isAddToCartLoading } =
    useMutation({
      mutationFn: addToCart,
      onSuccess: () => handleSuccessAddToCart(),
    });

  return (
    <div
      className="rounded-lg border-2 flex flex-col bg-white text-[14px]"
      key={index}
    >
      <div className="h-full">
        <img
          alt=""
          src={
            item?.media[0] !== ""
              ? item?.media[0].includes("{")
                ? item?.media[0].substring(1, item?.media[0]?.length - 1)
                : item?.media[0]
              : Logo
          }
          className="object-fit rounded-t-lg w-full object-cover cursor-pointer"
          onClick={() => navigate(`/purchase/product-detail/${item.id}`)}
        />
      </div>
      <div className="p-3.5 justify-between flex flex-col h-full">
        <p
          className="text-[14px] font-semibold truncate cursor-pointer hover:text-gray-400"
          onClick={() => navigate(`/purchase/product-detail/${item.id}`)}
        >
          {item.name}
        </p>
        <p className="text-gray-400 mb-2">{item.uom}</p>
        <p className="truncate">
          Rp {item.price?.toLocaleString().replaceAll(",", ".")}
        </p>

        {/* <div className="w-full flex gap-2 items-center mt-4">
          <div className="bg-blue-500 p-2 rounded-full w-8 h-8 text-white flex justify-center items-center">
            <AiOutlineShop className="h-full w-full" />
          </div>
          <p className="text-gray-400 truncate">{item.company_name}</p>
        </div> */}
        {/* <div className="w-full flex gap-2 items-center mt-2">
          <div className="bg-green-500 p-2 rounded-full w-8 h-8 text-white flex justify-center items-center">
            <IoLocationSharp className="h-full w-full" />
          </div>
          {item.url_latlong === "" || item.url_latlong === "-" ? (
            <p className="text-gray-400 truncate">{item.city}</p>
          ) : (
            <Link
              to={item.url_latlong}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 truncate hover:text-blue-500"
            >
              {item.city}
            </Link>
          )}
        </div> */}

        {item.isLoading ? (
          <div className="flex items-center rounded-md bg-[#EAEAEA] p-3.5 justify-center mt-8">
            Loading
          </div>
        ) : (
          <div>
            <div className="flex items-center rounded-full bg-[#EAEAEA] p-2 justify-between mt-4 w-full">
              <button
                className="bg-red-500 hover:bg-gray-300 text-white p-1 rounded-full disabled:bg-gray-300"
                disabled={isLoading || prodQuantity === 0}
                onClick={() => {
                  if (prodQuantity > 0) {
                    setProdQuantity(prodQuantity - 1);
                  }
                  if (item.quantity_buffer === 1) {
                    setItems((prevValue) =>
                      prevValue.map((data) => {
                        return data.id === item.id
                          ? {
                              ...data,
                              quantity_buffer: 0,
                            }
                          : data;
                      })
                    );
                    handleAddToCart({
                      company_id: item.company_id,
                      price: item.price,
                      product_id: item.id,
                      product_name: item.name,
                      image: item.media,
                      product_type: item.uom,
                      stock: item.stock,
                      quantity: 0,
                      prescription_image: recipeImg ? recipeImg : [],
                      check_state: false,
                      uuid: machineId,
                    });
                  } else {
                    setItems((prevValue) =>
                      prevValue.map((data) => {
                        return data.id === item.id
                          ? {
                              ...data,
                              quantity_buffer: data.quantity_buffer - 1,
                            }
                          : data;
                      })
                    );
                  }
                }}
              >
                <FaMinus className="text-white" />
              </button>
              <p>{prodQuantity}</p>
              <button
                className="bg-[#6F955B] text-white hover:bg-gray-300 p-1 rounded-full disabled:bg-gray-300"
                disabled={isLoading || prodQuantity === item.stock}
                onClick={() => {
                  if (item.stock === item.quantity_buffer) {
                    return;
                  }
                  setProdQuantity(prodQuantity + 1);
                  setItems((prevValue) =>
                    prevValue.map((data) => {
                      return data.id === item.id
                        ? {
                            ...data,
                            quantity_buffer: data.quantity_buffer + 1,
                          }
                        : data;
                    })
                  );
                }}
              >
                <FaPlus className="text-white" />
              </button>
            </div>
          </div>
        )}
        <button
          className="text-[12px] flex items-center rounded-md bg-[#4F5D75] hover:bg-[#3B485E] text-white p-2 justify-center mt-2 w-full disabled:bg-gray-400"
          disabled={
            item.quantity_buffer === 0 || isLoading || prodQuantity === 0
          }
          onClick={() => {
            if (
              item.product_label_id === 3 ||
              item.product_label_id === 4 ||
              item.product_label_id === 5
            ) {
              setOpenModalRecipe(true);
              setDoctorRecipe({
                product_id: item.id,
                company_id: item.company_id,
                quantity: item.quantity_buffer,
                product_name: item.name,
                freq_type: "per jam",
                consumed: "6 setiap jam",
                consumption_interval: "jumlah yang harus di minum 1",
                price: item.price * item.quantity_buffer,
                expired_at: item.expired_date,
                notes:
                  "Pemakaian obat umumnya memiliki efek samping tertentu dan sesuai dengan masing-masing individu. Jika terjadi efek samping yang berlebih dan berbahaya, harap konsultasikan kepada tenaga medis. Efek samping yang mungkin terjadi dalam penggunaan obat adalah: Anoreksia, mual dan gangguan GI.",
              });
              setAddToCartProduct({
                company_id: item.company_id,
                price: item.price,
                product_id: item.id,
                product_name: item.name,
                image: item.media,
                product_type: item.uom,
                stock: item.stock,
                quantity: item.quantity_buffer,
                prescription_image: recipeImg ? recipeImg : [],
                check_state: true,
                recipe_id: [recipeId],
                uuid: machineId,
              });
              setProdQuantity(0);
            } else {
              handleAddToCart({
                company_id: item.company_id,
                price: item.price,
                product_id: item.id,
                product_name: item.name,
                image: item.media,
                product_type: item.uom,
                stock: item.stock,
                quantity: item.quantity_buffer,
                prescription_image: recipeImg ? recipeImg : [],
                check_state: true,
                uuid: machineId,
              });
              setProdQuantity(0);
            }

            // Chat only available when logged in
            if (isLogin) {
              setChatRecipeResponse([
                {
                  id: 1,
                  message: `selamat siang dok, saya mau konsultasi untuk pengunaan ${item.product_name}, saya lupa pengunaanya harus berapa kali sehari?`,
                  img: null,
                  type: 1,
                  time: timeNow,
                },
                {
                  id: 2,
                  message: `Hi Selamat siang kak ${fullname} untuk pemakaian ${item.product_name} sebagai berikut:
                                        Dewasa: 1-2 Tablet, dihisap 4-5 kali perhari. Anak-anak: 1 tablet dihisap 4-5 kali perhari,`,
                  img: null,
                  type: 2,
                  time: timeNow,
                },
                {
                  id: 3,
                  message: "",
                  img: Mascot,
                  type: 1,
                  time: timeNow,
                },
              ]);
            }
          }}
        >
          {isAddToCartLoading ? (
            <FaSpinner className="animate-spin" />
          ) : (
            <>
              <IoCart className="mr-4" />
              <p>Tambah</p>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
